/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { CompanyTemperature } from "./CompanyTemperature";
import {
  CompanyTemperatureFromJSON,
  CompanyTemperatureFromJSONTyped,
  CompanyTemperatureToJSON,
  CompanyTemperatureToJSONTyped,
} from "./CompanyTemperature";
import type { InvoiceAuditProblem } from "./InvoiceAuditProblem";
import {
  InvoiceAuditProblemFromJSON,
  InvoiceAuditProblemFromJSONTyped,
  InvoiceAuditProblemToJSON,
  InvoiceAuditProblemToJSONTyped,
} from "./InvoiceAuditProblem";
import type { ControlsLtlFreight } from "./ControlsLtlFreight";
import {
  ControlsLtlFreightFromJSON,
  ControlsLtlFreightFromJSONTyped,
  ControlsLtlFreightToJSON,
  ControlsLtlFreightToJSONTyped,
} from "./ControlsLtlFreight";

/**
 *
 * @export
 * @interface ShipmentWithAuditProblems
 */
export interface ShipmentWithAuditProblems {
  /**
   *
   * @type {string}
   * @memberof ShipmentWithAuditProblems
   */
  shipmentId: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof ShipmentWithAuditProblems
   */
  bookedAt?: OffsetDateTime | null;
  /**
   *
   * @type {Array<InvoiceAuditProblem>}
   * @memberof ShipmentWithAuditProblems
   */
  invoiceAuditProblems: Array<InvoiceAuditProblem>;
  /**
   *
   * @type {string}
   * @memberof ShipmentWithAuditProblems
   */
  companyName: string;
  /**
   *
   * @type {ControlsLtlFreight}
   * @memberof ShipmentWithAuditProblems
   */
  controlsLtlFreight: ControlsLtlFreight;
  /**
   *
   * @type {string}
   * @memberof ShipmentWithAuditProblems
   */
  shipmentFrequency?: string | null;
  /**
   *
   * @type {string}
   * @memberof ShipmentWithAuditProblems
   */
  shipmentFrequencyNote?: string | null;
  /**
   *
   * @type {CompanyTemperature}
   * @memberof ShipmentWithAuditProblems
   */
  temperature?: CompanyTemperature | null;
}

/**
 * Check if a given object implements the ShipmentWithAuditProblems interface.
 */
export function instanceOfShipmentWithAuditProblems(
  value: object,
): value is ShipmentWithAuditProblems {
  if (!("shipmentId" in value) || value["shipmentId"] === undefined)
    return false;
  if (
    !("invoiceAuditProblems" in value) ||
    value["invoiceAuditProblems"] === undefined
  )
    return false;
  if (!("companyName" in value) || value["companyName"] === undefined)
    return false;
  if (
    !("controlsLtlFreight" in value) ||
    value["controlsLtlFreight"] === undefined
  )
    return false;
  return true;
}

export function ShipmentWithAuditProblemsFromJSON(
  json: any,
): ShipmentWithAuditProblems {
  return ShipmentWithAuditProblemsFromJSONTyped(json, false);
}

export function ShipmentWithAuditProblemsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShipmentWithAuditProblems {
  if (json == null) {
    return json;
  }
  return {
    shipmentId: json["shipmentId"],
    bookedAt: json["bookedAt"] == null ? undefined : json["bookedAt"],
    invoiceAuditProblems: (json["invoiceAuditProblems"] as Array<any>).map(
      InvoiceAuditProblemFromJSON,
    ),
    companyName: json["companyName"],
    controlsLtlFreight: ControlsLtlFreightFromJSON(json["controlsLtlFreight"]),
    shipmentFrequency:
      json["shipmentFrequency"] == null ? undefined : json["shipmentFrequency"],
    shipmentFrequencyNote:
      json["shipmentFrequencyNote"] == null
        ? undefined
        : json["shipmentFrequencyNote"],
    temperature:
      json["temperature"] == null
        ? undefined
        : CompanyTemperatureFromJSON(json["temperature"]),
  };
}

export function ShipmentWithAuditProblemsToJSON(
  json: any,
): ShipmentWithAuditProblems {
  return ShipmentWithAuditProblemsToJSONTyped(json, false);
}

export function ShipmentWithAuditProblemsToJSONTyped(
  value?: ShipmentWithAuditProblems | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    shipmentId: value["shipmentId"],
    bookedAt: value["bookedAt"],
    invoiceAuditProblems: (value["invoiceAuditProblems"] as Array<any>).map(
      InvoiceAuditProblemToJSON,
    ),
    companyName: value["companyName"],
    controlsLtlFreight: ControlsLtlFreightToJSON(value["controlsLtlFreight"]),
    shipmentFrequency: value["shipmentFrequency"],
    shipmentFrequencyNote: value["shipmentFrequencyNote"],
    temperature: CompanyTemperatureToJSON(value["temperature"]),
  };
}
